import sendRequest from "@/libs/sendRequest";

export const targetGroup = {
  namespaced: true,

  state: {
    // Para target groups
    targets: {
      data: [],
      total: 0,
      loading: false,
      error: false
    },

    options: {
        data: [],
        loading: false,
        error: null
    },
    
    // Para rutas
    rutas: {
      data: [],
      loading: false,
      error: null
    },
    
    // Para clientes
    clients: {
      data: [],
      total: 0,
      loading: false,
      error: null
    }
  },

  getters: {
    // Target groups
    getTargets: (state) => state.targets.data,
    getTargetsTotal: (state) => state.targets.total,
    isTargetsLoading: (state) => state.targets.loading,
    getTargetError:  (state) => state.targets.error,

    // Options
    getOptions: (state) => state.options.data,

    // Rutas
    getRutas: (state) => state.rutas.data,
    isRutasLoading: (state) => state.rutas.loading,
    
    // Clientes
    getClients: (state) => state.clients.data,
    getClientsTotal: (state) => state.clients.total,
    isClientsLoading: (state) => state.clients.loading
  },

  mutations: {
    // Target groups
    SET_TARGETS: (state, payload) => {
      state.targets.data = payload;
    },
    SET_TARGETS_TOTAL: (state, payload) => {
      state.targets.total = payload;
    },
    SET_TARGETS_LOADING: (state, payload) => {
      state.targets.loading = payload;
    },
    SET_TARGETS_ERROR: (state, payload) => {
      state.targets.error = payload;
    },

    // Options
    setOptions: (state, payload) => {
        state.options.data = payload;
    },
    
    // Rutas
    SET_RUTAS: (state, payload) => {
      state.rutas.data = payload;
    },
    SET_RUTAS_LOADING: (state, payload) => {
      state.rutas.loading = payload;
    },
    SET_RUTAS_ERROR: (state, payload) => {
      state.rutas.error = payload;
    },
    
    // Clientes
    SET_CLIENTS: (state, payload) => {
      state.clients.data = payload;
    },
    SET_CLIENTS_TOTAL: (state, payload) => {
      state.clients.total = payload;
    },
    SET_CLIENTS_LOADING: (state, payload) => {
      state.clients.loading = payload;
    },
    SET_CLIENTS_ERROR: (state, payload) => {
      state.clients.error = payload;
    }
  },

  actions: {
    // Listar target groups
    async list({ commit, rootGetters }, { isDatatable = true, page = 1, rows = 10, search = '', order_by = 'Id', order_asc = true }) {
        commit('SET_TARGETS_LOADING', true);
        commit('SET_TARGETS_ERROR', false);
        const custom_headers = rootGetters.getHeaders;

        const datatable = {
            isDatatable,
            page,
            rows,
            search,
            order_by,
            order_asc
        }

        try {
            const response = await sendRequest(`administrator/heishop/target/list`, 'GET', null, null, datatable, custom_headers);
            if(datatable.isDatatable) {
                commit('SET_TARGETS', response.data.list.result);
                commit('SET_TARGETS_TOTAL', response.data.list.total_rows);
            }
            else {
                commit('setOptions', response.data.list);
            }
        }
        catch (error) {
            commit('SET_TARGETS_ERROR', error.message || 'Error al cargar targets');
            console.error('Error en list:', error);
            throw error;
        } 
        finally {
            commit('SET_TARGETS_LOADING', false);
        }
    },

    // Agregar nuevo target group
    async add({ commit, dispatch, rootGetters }, body) {
        dispatch('showLoading', null, { root: true })
        commit('SET_TARGETS_ERROR', false);
        const custom_headers = rootGetters.getHeaders;
        console.log(body)
        const response = await sendRequest(`administrator/heishop/target/add`, 'POST', null, body, null, custom_headers)

        if(response.success && response.data) {
            dispatch('showAlert', 'TargetGroup Actualizado', { root: true })
            dispatch('hiddenLoading', null, { root: true })
        }
        else if(!response.success && response.errors) {
            dispatch('showError', 'Ah ocurrido un error, intente nuevamente', { root: true })
            commit('SET_TARGETS_ERROR', true);
            dispatch('hiddenLoading', null, { root: true })
        }
        else {

        }
    },

    // Obtener rutas para multiselect
    async fetchRutas({ commit, rootGetters }) {
      commit('SET_RUTAS_LOADING', true);
      commit('SET_RUTAS_ERROR', null);
      
      const custom_headers = rootGetters.getHeaders;
      
      try {
        const response = await sendRequest(
          `administrator/heishop/rutas`,
          'GET',
          null,
          null,
          null,
          custom_headers
        );
    
        if (!response?.data?.rutas) {
          throw new Error('Formato de respuesta inesperado');
        }
    
        const rutasMapped = Array.isArray(response.data.rutas)
          ? response.data.rutas
              .filter(ruta => ruta.ruta?.toLowerCase().startsWith('p'))
              .map(ruta => ({
                value: ruta.ruta || '',
                label: ruta.ruta || 'Ruta sin nombre',
                rawData: ruta,
              }))
          : [];
    
        commit('SET_RUTAS', rutasMapped);
        return rutasMapped;
      } catch (error) {
        commit('SET_RUTAS_ERROR', error.message || 'Error al cargar rutas');
        console.error('Error en fetchRutas:', error);
        throw error;
      } finally {
        commit('SET_RUTAS_LOADING', false);
      }
    },

    // Obtener clientes
    async fetchClients({ commit, rootGetters },{ ruta = '' }) {
        commit('SET_CLIENTS_LOADING', true);
        commit('SET_CLIENTS_ERROR', null);
      
        const custom_headers = rootGetters.getHeaders;
      
        try {
          let url = 'administrator/heishop/clientes/list';

          if (ruta) {
            url += `?ruta=${encodeURIComponent(ruta)}`;
          }
          const response = await sendRequest(
            url,
            'GET',
            null,
            null,
            null,
            custom_headers
          );
          console.log(response);
          if (
            !response?.data ||
            !response.data.list ||
            !Array.isArray(response.data.list)
          ) {
            throw new Error(response?.errors?.[0]?.message || 'Estructura de respuesta inválida');
          }
      
          const clientsMapped = response.data.list.map(client => ({
            value: client.ClaveFerguez || '',
            label: client.ClaveFerguez || 'Cliente sin clave',
            rawData: client,
          }));
      
          commit('SET_CLIENTS', clientsMapped);
          commit('SET_CLIENTS_TOTAL', response.data.list.total_rows || 0);

          return clientsMapped;
        } catch (error) {
          commit('SET_CLIENTS_ERROR', error.message || 'Error al cargar clientes');
          console.error('Error en fetchClients:', error);
          throw error;
        } finally {
          commit('SET_CLIENTS_LOADING', false);
        }
    }
      
      
  
  }
};